// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__B0g6M","rootSuccess":"CompleteLink_rootSuccess__1og3C","rootFailure":"CompleteLink_rootFailure__19Llh","isDisabled":"CompleteLink_isDisabled__2Flrc"};